import { splitWords } from "./manifesto";

export type Lang = "en" | "de" | "fr";

const STORAGE_KEY = "bs_lang";

export function initLang(manifestoEl: HTMLElement | null): void {
  const langButtons =
    document.querySelectorAll<HTMLButtonElement>(".lang-btn");

  function applyLang(lang: Lang): void {
    document.documentElement.lang = lang;
    document.querySelectorAll<HTMLElement>("[data-en]").forEach((el) => {
      const txt = el.getAttribute("data-" + lang);
      if (txt !== null) el.innerHTML = txt;
    });
    document
      .querySelectorAll<HTMLElement>("[data-en-placeholder]")
      .forEach((el) => {
        const txt = el.getAttribute("data-" + lang + "-placeholder");
        if (txt !== null) el.setAttribute("placeholder", txt);
      });
    langButtons.forEach((b) =>
      b.classList.toggle("active", b.dataset.lang === lang),
    );
    if (manifestoEl && manifestoEl.querySelector(".word") === null) {
      splitWords(manifestoEl);
      if (manifestoEl.classList.contains("in")) {
        manifestoEl.classList.remove("in");
        requestAnimationFrame(() => manifestoEl.classList.add("in"));
      }
    }
    try {
      localStorage.setItem(STORAGE_KEY, lang);
    } catch {
      /* localStorage unavailable */
    }
  }

  langButtons.forEach((b) =>
    b.addEventListener("click", () => {
      const lang = b.dataset.lang as Lang | undefined;
      if (lang === "en" || lang === "de" || lang === "fr") applyLang(lang);
    }),
  );

  let saved: string | null = null;
  try {
    saved = localStorage.getItem(STORAGE_KEY);
  } catch {
    /* localStorage unavailable */
  }
  if (saved === "en" || saved === "de" || saved === "fr") {
    applyLang(saved);
  } else {
    const nav = (navigator.language || "").toLowerCase();
    if (nav.startsWith("de")) applyLang("de");
    else if (nav.startsWith("fr")) applyLang("fr");
  }
}
